import React, { useState } from 'react';
import type { FC } from 'react';
import InkTextInput from 'ink-text-input';

interface Props {
  placeholder?: string;
  onSubmit?: (value: string) => void;
  onChange?: (value: string) => void;
  showCursor?: boolean;
}

export const Input: FC<Props> = ({
  onSubmit,
  onChange,
  placeholder,
  showCursor,
}) => {
  const [currentValue, setCurrentValue] = useState<string>('');

  return (
    <InkTextInput
      showCursor={showCursor}
      placeholder={placeholder}
      value={currentValue}
      onChange={(value) => {
        setCurrentValue(value);
        onChange?.(value);
      }}
      onSubmit={() => {
        if (!currentValue && placeholder) {
          onSubmit?.(placeholder);
        } else {
          onSubmit?.(currentValue);
        }
      }}
    />
  );
};
